module.exports = __webpack_public_path__ + "static/fonts/eui-font.923fb7c.eot";